import classcat from "classcat";
import React from "react";

import { IconArrowRight } from "@touchtech/web-baselayer-ui";

import { SearchTerm } from "@is/types";

import css from "./AttributeOption.module.css";
import useManageAttributeOption from "./hooks/useManageAttributeOption";

type Props = {
  value: SearchTerm;
  onClick: (value: SearchTerm) => void;
};

const AttributeOption = ({ value, onClick }: Props) => {
  const { handleClick } = useManageAttributeOption({ value, onClick });

  return (
    <button
      onClick={handleClick}
      className={classcat([css.container, "text-label-2xl"])}
    >
      <div className={css.text}>
        <strong>{value.label ?? value.value}</strong>
      </div>
      <div className={css.iconContainer}>
        <IconArrowRight className={classcat([css.icon, "text-label-3xl"])} />
      </div>
    </button>
  );
};

export default AttributeOption;
